import { PublicClientApplication } from "@azure/msal-browser";

export const b2cPolicies = {
  authorities: {
    signIn: {
      authority: process.env.REACT_APP_AZURE_AUTHORITY_LOGIN,
    },
    signUp: {
      authority: process.env.REACT_APP_AZURE_AUTHORITY_SIGNUP,
    },
    forgotPassword: {
      authority: process.env.REACT_APP_AZURE_AUTHORITY_FORGOT_PASSWORD,
    },
    resetPassword: {
      authority: process.env.REACT_APP_AZURE_AUTHORITY_RESET_PASSWORD,
    },
  },
};

// Try alternative configuration if endpoints resolution fails
const createMsalConfig = () => {
  const baseConfig = {
    auth: {
      authority: b2cPolicies.authorities.signIn.authority,
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
      postLogoutRedirectUri: `${window.location.origin}/`,
      redirectUri: window.location.origin,
      knownAuthorities: [process.env.REACT_APP_AZURE_KNOWN_AUTHORITIES],
      validateAuthority: true,
      navigateToLoginRequestUrl: true,
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };

  return baseConfig;
};

export const msalConfig = createMsalConfig();

export const apiScope = { scopes: [process.env.REACT_APP_AZURE_API_SCOPE] };
export const loginScope = { scopes: [process.env.REACT_APP_AZURE_CLIENT_ID] };

// Create MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Track initialization state
let isInitializing = false;
let isInitialized = false;
let initializationPromise = null;

// Initialize the application and handle redirect promise
const initializeMsal = async () => {
  // Prevent multiple simultaneous initializations
  if (isInitializing) {
    return initializationPromise;
  }

  if (isInitialized) {
    return Promise.resolve();
  }

  isInitializing = true;
  initializationPromise = (async () => {
    try {
      await msalInstance.initialize();

      // Handle redirect promise after initialization
      const response = await msalInstance.handleRedirectPromise();
      /* if (response) {
        // The authority used is available in the response
        const usedAuthority = response.authority;
        // Check which policy was used for potential future logic
      } */

      isInitialized = true;
      return response;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("MSAL initialization or redirect handling failed:", error);
      throw error;
    } finally {
      isInitializing = false;
    }
  })();

  return initializationPromise;
};

// Export initialization function for use in AzureWrapper
export const ensureMsalInitialized = initializeMsal;

/**
 * Logout function with ID token hint support
 * @param {string} customRedirectUri - Optional custom redirect URI after logout
 * @returns {Promise} - Promise that resolves when logout redirect is initiated
 */
export const logout = async (customRedirectUri = null) => {
  sessionStorage.clear();
  // Ensure MSAL is initialized
  await ensureMsalInitialized();

  await msalInstance.handleRedirectPromise();

  // Get active account
  const accounts = msalInstance.getAllAccounts();

  // Try to get id token from account or storage
  let idToken = null;
  if (accounts[0] && accounts[0].idToken) {
    idToken = accounts[0].idToken;
  }

  // Set post logout redirect URI
  const postLogoutRedirectUri = customRedirectUri || `${window.location.origin}/`;

  // Call logoutRedirect with id_token_hint if available
  return msalInstance.logoutRedirect({
    postLogoutRedirectUri,
    idTokenHint: idToken,
  });
};

export { msalInstance as authProvider };
